var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle])},[_c('b-progress',{attrs:{"value":_vm.props.value,"min":0,"max":100,"variant":"success","show-progress":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }